import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Modal, Box, Typography, Stack, Button, Divider } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { generateTimeSlots } from './TimeSlots';
import { Group, Person } from '@mui/icons-material';
import { defaultStartTime, defaultEndTime, defaultSlotSize, defaultMaxPeople, defaultMaxGroups } from 'shared';
import { timeSlotPurchases } from '../screens/admin/Schedule';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { parseDateAndTime, timeToSeconds } from '../helpers';
import dayjs from 'dayjs';
import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  border: 0,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  maxHeight: "80%",
  overflow: "scroll",
  scroll: "auto",
};

export default function SlotEditModal({ purchases, timeSlots, timeZone, selectedPurchase, open = false, onClose }) {
  const handleOnClose = () => {
    if (onClose) onClose();
  }

  const getSlotInfo = useCallback((time) => {
    const slotPurchases = timeSlotPurchases(purchases, time, timeZone);
    return {
      people: slotPurchases.reduce((acc, curr) => acc + curr.groupSize, 0),
      groups: slotPurchases.length,
    }
  }, [purchases, timeZone]);


  const handleSlotChange = async (time) => {
  
    // update the purchase
    const newDateTime = parseDateAndTime(dayjs(selectedPurchase.selectedDateTime.toDate()), time, timeZone);
    await updateDoc(doc(db, "ticketPurchases", selectedPurchase.id), {
      selectedDate: newDateTime,
      selectedDateTime: newDateTime,
    });

    const emailRef = doc(db, `emails/${selectedPurchase.id}`);
    await updateDoc(emailRef, {
      "dynamicTemplateData.date": formatInTimeZone(newDateTime, timeZone, 'PPPP'),
      "dynamicTemplateData.time": formatInTimeZone(newDateTime, timeZone, 'HH:mm'),
    });

    onClose();
  }

  const handleHidePurchase = async () => {
    console.log("hide purchase, sets to midnight");
    const newDateTime = parseDateAndTime(dayjs(selectedPurchase.selectedDateTime.toDate()), "00:00", timeZone);
    await updateDoc(doc(db, "ticketPurchases", selectedPurchase.id), {
      selectedDate: newDateTime,
      selectedDateTime: newDateTime,
    });

    onClose();
  }

  return <>
      <Modal
        open={open}
        onClose={() => handleOnClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="h6" component="h2" sx={{
            textAlign: "center",
            mb: 4,
          }}>
            Move to another time
            
          </Typography>

          <Button variant="outlined" size="small" color="error" onClick={() => {
            window.confirm("Are you sure you want to remove them from the list?") && handleHidePurchase();
          }}>Remove from list</Button>
   
            <Stack>
        {/* Filter out the selected time or if past present time if today */}
        {timeSlots.filter(slot => 
          slot !== selectedPurchase.time && (
          format(selectedPurchase.selectedDateTime.toDate(), 'yyyy-MM-dd') === format(new Date(), 'yyyy-MM-dd') ?
          timeToSeconds(slot) > new Date().getTime() - (defaultSlotSize * 60*1000) : 
          true)
        ).map((slot) => (
          <Box key={slot}>
                  <Button onClick={() => handleSlotChange(slot)} style={{width: "100%", margin:0, padding: 20, flexDirection: "column"}}>
                    <Box sx={{display: "flex", justifyContent: "space-between"}}>
                      <Typography sx={{fontWeight: "bold", fontSize: "1.2rem"}}>{slot}</Typography>
                    </Box>
                    <Box sx={{display: "flex-row", alignItems: "center", mt: 0.5}}>
                      <Typography sx={{display: "flex", gap: 1}}>
                        People: <b>{getSlotInfo(slot).people} / {defaultMaxPeople}</b>
                        {/* <Person />  */}
                      </Typography>
                      <Typography sx={{display: "flex", gap: 1}}>
                        Groups: <b>{getSlotInfo(slot).groups} / {defaultMaxGroups}</b>
                        {/* <Group />  */}
                      </Typography>
                    </Box>
                  </Button>
                  <Divider />
                </Box>
           
              ))}
  
            </Stack>
    
        </Box>
      </Modal>
  </>
}
